<template>
  <div id="container" :style="{ height: 700 + 'px' }">
    <ul id="chat-list" class="m-chat-list p-chat-list" ref="chat">
      <chat-item
        v-for="(msg, index) in msglist"
        :type="type"
        :rawMsg="msg"
        :isRobot="isRobot"
        :userInfos="userInfos"
        :myInfo="myInfo"
        :key="msg.idClient || index"
        :isHistory="isHistory"
        @msg-loaded="msgLoaded"
        @on-pic-add="onPicAdd"
        @on-avatar="onAvatar"
      ></chat-item>
      <!-- 发送消息进度条 -->
      <el-popover
        placement="right"
        width="400"
        trigger="click"
        v-model="progress_visible"
      >
        <el-progress :percentage="progressText" status="success"></el-progress>
        <!-- <el-progress type="circle" :percentage="progressText"></el-progress> -->
      </el-popover>
      <div id="bot"></div>
      <el-dialog
        title="图片收藏"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose"
      >
        <el-form ref="caseForm" :rules="caseRules" label-width="80px">
          <el-form-item label="照片类别" prop="eye_type">
            <el-radio v-model="caseForm.eye_type" label="1">左眼</el-radio>
            <el-radio v-model="caseForm.eye_type" label="2">右眼</el-radio>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="filmAdd()">确 定</el-button>
        </span>
      </el-dialog>
    </ul>
  </div>
</template>
<script type="text/javascript">
import util from "@/utils";
import config from "@/config/config";
import emojiObj from "@/config/emoji";
import ChatItem from "./ChatItem";

import { filmAdd } from "@/api/index.js";
export default {
  components: {
    ChatItem,
  },
  props: {
    type: String, // 类型，chatroom, session
    canLoadMore: [String, Boolean],
    caseId: {
      type: Number,
    },
    isRobot: {
      type: Boolean,
      default() {
        return false;
      },
    },
    msglist: {
      type: Array,
      default() {
        return [];
      },
    },
    userInfos: {
      type: Object,
      default() {
        return {};
      },
    },
    myInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    isHistory: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      num: 1,
      isFullImgShow: false,
      msgLoadedTimer: null,
      dialogVisible: false,
      screenHeight: 500,
      filmSrc: "",
      remarks: "",
      caseForm: {
        eye_type: "",
      },
      caseRules: {
        eye_type: [
          {
            required: true,
            message: "请选择类型",
            trigger: "blur",
          },
        ],
      },
      progress_visible: false,
      progressText: 0,
    };
  },
  computed: {
    percentageText() {
      return this.$store.state.percentageText;
    },
  },
  created() {
    this.screenHeight = document.body.scrollHeight - 257;
  },
  watch: {
    percentageText(curVal, oldVal) {
      this.progress_visible = curVal > 0 && curVal < 100 ? true : false;
      this.progressText = +curVal;
    },
  },
  methods: {
    handleClose(done) {
      done();
    },
    showFullImg(src) {
      this.$store.dispatch("showFullscreenImg", {
        src,
      });
    },
    msgLoaded() {
      clearTimeout(this.msgLoadedTimer);
      this.msgLoadedTimer = setTimeout(() => {
        document.getElementById("bot").scrollIntoView();
        this.$emit("msgs-loaded");
      }, 20);
    },
    onPicAdd(item) {
      // this.filmSrc = item.file.url;
      // this.remarks = "";
      // this.dialogVisible = true;
      console.log("图片收藏已取消");
    },
    onAvatar(item) {
      this.$emit("on-list-avatar", item);
      console.log(item);
    },
    filmAdd() {
      let data = {
        image: this.filmSrc,
        cases_id: this.caseId,
        type: this.caseForm.eye_type,
      };
      console.log("data:", data);
      filmAdd(data).then((res) => {
        if (res.code == 1) {
          this.$message({
            type: "success",
            message: "加入阅片成功",
          });
        } else {
          this.$message({
            type: "error",
            message: "加入阅片失败",
          });
        }
        this.dialogVisible = false;
      });
    },
  },
};
</script>

<style lang="scss" type="text/css">
#container {
  width: 100%;
  overflow: hidden;
  overflow-y: scroll;
  overflow-x: auto;
  .p-chat-list {
    .u-icon {
      width: 1.4rem;
      height: 1.6rem;
      margin-right: 0.2rem;
      vertical-align: bottom;
    }
  }
  #chat-list {
    display: flex;
    max-width: 60vw;
    flex-direction: column;
  }

  .item-time {
    text-align: center;
  }

  .m-chat-list {
    margin-bottom: 20px;
  }

  .el-popover {
    top: 50%;
    left: 25%;
  }
}
</style>
